import * as React from "react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";

// Envuelve cualquier elemento (icono, badge, link, etc.) con un tooltip accesible.
// Requiere <TooltipProvider> global (montado en App.js).
export function WithTooltip({ text, children, side = "top", asChild = true }) {
  if (!text) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-left">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}

// Botón con tooltip integrado + aria-label automático (para icon-only y acciones no obvias).
// Uso: <TooltipButton tooltip="Eliminar" variant="ghost" size="icon" onClick={...}><Trash2/></TooltipButton>
export const TooltipButton = React.forwardRef(function TooltipButton(
  { tooltip, ariaLabel, children, ...props },
  ref,
) {
  const label = ariaLabel || (typeof tooltip === "string" ? tooltip : undefined);
  const btn = (
    <Button ref={ref} aria-label={label} {...props}>
      {children}
    </Button>
  );
  return tooltip ? <WithTooltip text={tooltip}>{btn}</WithTooltip> : btn;
});
